import { PageObjectType } from '@pages/setting/PageConfigurationDetail/pageConfigurationTypes';
import { objectFilter } from '@utils/objectFilter';

type WithdrawSubAccountFilterArgs = {
  contextObjectType?: string | null;
  contextObjectId?: string | null;
  completionObjectType?: string | null;
  completionObjectId?: string | null;
  userId?: string;
};

export const withdrawSubAccountFilter = ({
  contextObjectType,
  contextObjectId,
  completionObjectType,
  completionObjectId,
  userId,
}: WithdrawSubAccountFilterArgs) => {
  const objectType = contextObjectType ?? completionObjectType;
  const objectId =
    contextObjectId ?? (contextObjectType ? undefined : completionObjectId);

  if (!objectId) return { userId };

  if (objectType === PageObjectType.HOUSEHOLD) {
    return { clientGroupId: objectId, includeHousehold: true };
  }

  return objectFilter(objectType as PageObjectType | undefined, objectId);
};

export const internalTransferSourceFilter = ({
  contextObjectType,
  contextObjectId,
  completionObjectType,
  completionObjectId,
  userId,
}: WithdrawSubAccountFilterArgs) => {
  const householdId =
    contextObjectType === PageObjectType.HOUSEHOLD
      ? contextObjectId
      : !contextObjectType && completionObjectType === PageObjectType.HOUSEHOLD
        ? completionObjectId
        : undefined;

  if (householdId) {
    return { clientGroupId: householdId, includeHousehold: true };
  }

  return { userId };
};
